<template>
  <footer id="footer">
    <div class="top">
      <div class="inner">
        <ul class="link">
          <li>
            <button
              title="개인정보처리방침"
              @click="$openUrl('https://www.asanfmc.or.kr/new/cms/?no=185')"
            >
              개인정보처리방침
            </button>
          </li>
          <li>
            <button
              title="이용약관"
              @click="$openUrl('https://www.asanfmc.or.kr/new/termsofuse.php')"
            >
              이용약관
            </button>
          </li>
          <li>
            <button
              title="영상정보처리기기 운영·관리 방침"
              @click="
                $openUrl(
                  'https://www.asanfmc.or.kr/new/imageryintelligence.php',
                )
              "
            >
              영상정보처리기기 운영·관리 방침
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom">
      <div class="inner">
        <div class="flex">
          <h1 class="footer-logo">
            <img
              :src="require('@/assets/images/common/footer-logo.png')"
              alt="아산시시설관리공단 로고(하단)"
            />
          </h1>
          <address class="footer-address">
            <p class="address">
              아산시시설관리공단<br class="mobile" />
              <span class="start">
                [31480] 충청남도 아산시 배방읍 배방로14번길 6
              </span>
            </p>
            <p class="address">
              TEL 041-590-0852
              <br class="mobile" />
              <span class="start web">|</span>
              <span class="start">FAX 041-533-6981</span>
              <br class="mobile" />
              <span class="start web">|</span>
              <span class="start">대표자명 김효섭</span>
              <br class="mobile" />
              <span class="start web">|</span>
              <span class="start">사업자번호 312-82-19072</span>
            </p>
            <p class="copyright">
              Ⓒ {{ nowYear }}ASAN FACILITIES MANAGEMENT CORPOR ATION. ALL RIGHTS
              RESERVED.
            </p>
          </address>
        </div>
        <div class="family-site">
          <label for="familySite" class="hidden">아산시 패밀리 사이트 </label>
          <select
            title="패밀리사이트 선택"
            id="familySite"
            @change="goExternalSite"
            ref="moveSite"
          >
            <option value="/main" selected>관련기관 사이트</option>
            <option value="https://www.asan.go.kr/main/">아산시청</option>
            <option value="https://www.asanfmc.or.kr/new/">
              아산시시설관리공단
            </option>
          </select>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      nowYear: new Date().getFullYear(),
    };
  },
  methods: {
    goExternalSite() {
      this.$openUrl(this.$refs.moveSite.value);

      this.$refs.moveSite.value = '/main';
    },
  },
};
</script>
